import { h } from '@atomify/jsx';
import { MapLabel } from '@atoms/map-label';
import { extendMapTheme, GREY_DARK, HOVER, MapThemeExtension, RED, THEME } from '@utilities/map';

export const PROPERTIES_THEME: MapThemeExtension = extendMapTheme(THEME, {
    polygon: {
        settings: [
            {
                variant: `projectPhaseSold`,
                normal: {
                    fill: [...RED, 0.5],
                    stroke: [...GREY_DARK, 1],
                },
                hover: HOVER,
            },
            {
                variant: `hidden`,
                visibility: 'none',
                normal: {},
            },
        ],
    },
    pointer: {
        settings: [
            {
                variant: 'projectPhaseSoldPointer',
                disablePointerEvents: true,
                createElement: (item) => <MapLabel title={item.title} subtitle={item.status} />,
            },
        ],
    },
});
